import { CSSProperties, FC, ReactNode } from 'react';
import { StyledTypography } from './text.styles';

const colorMap = {
  neutralVeryDark: '#111',
  neutralVeryLight: '#FFF',
  primaryDark: '#004C87',
};

type Colors = keyof typeof colorMap;

export type TypographyProps = {
  variant?: keyof typeof StyledTypography;
  color?: Colors;
  nowrap?: boolean;
  align?: 'start' | 'center' | 'end';
  children?: ReactNode | string;
  role?: string;
  whiteSpace?: boolean;
  style?: CSSProperties;
};

export function Text({
  variant = 'Body1',
  role,
  align,
  nowrap = false,
  whiteSpace,
  color = 'neutralVeryDark',
  children,
  style,
}: Readonly<TypographyProps>) {
  const Component = StyledTypography[variant] as FC<any>;

  const computedWhiteSpace: CSSProperties['whiteSpace'] =
    nowrap ? 'nowrap' : whiteSpace ? 'pre-wrap' : undefined;

  return (
    <Component
      role={role}
      style={{
        ...style,
        color: colorMap[color],
        textAlign: align,
        whiteSpace: computedWhiteSpace,
        overflow: nowrap ? 'hidden' : style?.overflow,
        textOverflow: nowrap ? 'ellipsis' : style?.textOverflow,
      }}
    >
      {children}
    </Component>
  );
}

export const Typography = Text;